/* eslint-disable max-len */
import {
  FunctionComponent,
} from 'react';
import { Route } from 'react-router-dom';

import { AdminRouteName } from '../CONSTANTS';
import AllCustomers from './Allcustomers/AllCustomers';
import DashboardWrap from '../../components/DashboardWrap';
import ActiveCustomers from './ActiveCustomers';
import InactiveCustomers from './InactiveCustomers';
import AwaitingApprovalCustomers from './AwaitingApprovalCustomer';
import ProspectiveCustomers from './PropectiveCustomer';

import './customers.scss';

const AdminCustomers: FunctionComponent = () => (
  <DashboardWrap>
    <div className="customer-root-cover">
      <Route component={AllCustomers} path={AdminRouteName.customersRoute} exact />
      <Route component={ActiveCustomers} path={AdminRouteName.activeCustomersRoute} />
      <Route component={InactiveCustomers} path={AdminRouteName.inactiveCustomersRoute} />
      <Route component={AwaitingApprovalCustomers} path={AdminRouteName.awaitingApprovedCustomersRoute} />
      <Route component={ProspectiveCustomers} path={AdminRouteName.prospectiveCustomersRoute} />

    </div>
  </DashboardWrap>
);

export default AdminCustomers;
